import { Sidebar, SidebarContent, SidebarGroup, SidebarGroupContent, SidebarGroupLabel, SidebarMenu, SidebarMenuButton, SidebarMenuItem } from "@/components/ui/sidebar";
import { SidebarProvider } from "@/components/ui/sidebar";
import { Users, Settings, BarChart3, ShoppingCart, Bot, Mic2 } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface AdminLayoutProps {
  children: React.ReactNode;
}

const menuItems = [
  {
    title: "Customers",
    icon: Users,
    path: "/admin/customers"
  },
  {
    title: "Plans",
    icon: Settings,
    path: "/admin/plans"
  },
  {
    title: "Reports",
    icon: BarChart3,
    path: "/admin/reports"
  },
  {
    title: "Shopify",
    icon: ShoppingCart,
    path: "/admin/integrations/shopify"
  },
  {
    title: "AI Services",
    icon: Bot,
    path: "/admin/integrations/ai"
  },
  {
    title: "Voice Services",
    icon: Mic2,
    path: "/admin/integrations/voice"
  }
];

export const AdminLayout = ({ children }: AdminLayoutProps) => {
  const navigate = useNavigate();

  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full">
        <Sidebar>
          <SidebarContent>
            <SidebarGroup>
              <SidebarGroupLabel>Admin Panel</SidebarGroupLabel>
              <SidebarGroupContent>
                <SidebarMenu>
                  {menuItems.map((item) => (
                    <SidebarMenuItem key={item.path}>
                      <SidebarMenuButton onClick={() => navigate(item.path)}>
                        <item.icon className="h-4 w-4 mr-2" />
                        <span>{item.title}</span>
                      </SidebarMenuButton>
                    </SidebarMenuItem>
                  ))}
                </SidebarMenu>
              </SidebarGroupContent>
            </SidebarGroup>
          </SidebarContent>
        </Sidebar>
        <main className="flex-1 p-6">
          {children}
        </main>
      </div>
    </SidebarProvider>
  );
};